import _ from 'lodash';
import detectRoute, {
  POST_PAGE,
  CATEGORIES_PAGE,
  FEED_PAGE,
  SEARCH_RESULTS,
  USER_PROFILE,
  USER_EDIT_PROFILE,
  NOTIFICATIONS,
  CREATE_POST,
  USER_SETTINGS,
  POST_EDIT_PAGE,
} from '../services/detect-route';
import {
  getCategorySlugFromPathname,
  getReferrer,
  getCurrentOrigin,
  getPostSlugFromPathname,
  getImageCount,
  getVideoCount,
  getQuoteCount,
} from '../bi-events/bi-helpers';
import { LOCATION_CHANGE } from 'react-router-redux';
import * as modalTypes from '../constants/modal-types';
import { ACTIONS_CLOSED } from '../actions/actions-closed';
import { ACTIONS_OPENED } from '../actions/actions-opened';
import { APPLICATION_LOADED } from '../actions/application-loaded';
import { BUTTON_CLICKED } from '../actions/button-clicked';
import { CHANGE_PAGE } from '../actions/change-page';
import { CREATE_COMMENT_SUCCESS } from '../actions/create-comment';
import { CREATE_POST_SUCCESS } from '../actions/create-post';
import { DELETE_POST_SUCCESS } from '../actions/delete-post';
import { DEMOTE_MODERATOR_SUCCESS } from '../actions/demote-moderator';
import { FETCH_SEARCH_SUCCESS } from '../actions/fetch-search';
import { HIDE_MODAL } from '../actions/hide-modal';
import { INCREMENT_COMMENT_LIKE_COUNT_SUCCESS } from '../actions/increment-comment-like-count';
import { INCREMENT_POST_LIKE_COUNT_SUCCESS } from '../actions/increment-post-like-count';
import { INLINE_TOOLBAR_SHOW } from '../actions/inline-toolbar-shown';
import { PAGE_OPENED } from '../actions/page-opened';
import { PROMOTE_MODERATOR_SUCCESS } from '../actions/promote-moderator';
import { SUBSCRIBE_SUCCESS } from '../actions/subscribe';
import { UNSUBSCRIBE_SUCCESS } from '../actions/unsubscribe';
import { UPDATE_POST_SUCCESS } from '../actions/update-post';
import { UPDATE_USER_SUCCESS, UPDATE_USER_REQUEST } from '../actions/update-user';
import { TYPE_IMAGE } from '../actions/upload';
import { UPLOAD_ENDED } from '../actions/upload-ended';
import { UPLOAD_STARTED } from '../actions/upload-started';
import getQueryString from '../services/get-query-string';
import { getCategoryBySlug } from '../selectors/categories-selectors';
import { getCurrentLocation } from '../selectors/location-history-selectors';
import { getPostBySlug } from '../selectors/post-selectors';

export const eventMap = {
  [APPLICATION_LOADED]: () => ({
    evid: 704,
    vsi: getQueryString('vsi'),
  }),
  [SUBSCRIBE_SUCCESS]: (action, state) => {
    switch (action.payload.type) {
      case 'user':
        return {
          evid: 515,
          flag: 1,
          origin: getCurrentOrigin(state),
        };
      case 'post':
        return {
          evid: 553,
          flag: 1,
          origin: getCurrentOrigin(state),
        };
      case 'category':
        return {
          evid: 554,
          flag: 1,
          origin: getCurrentOrigin(state),
        };
      default:
        return;
    }
  },
  [UNSUBSCRIBE_SUCCESS]: (action, state) => {
    switch (action.payload.type) {
      case 'user':
        return {
          evid: 515,
          flag: 0,
          origin: getCurrentOrigin(state),
        };
      case 'post':
        return {
          evid: 553,
          flag: 0,
          origin: getCurrentOrigin(state),
        };
      case 'category':
        return {
          evid: 554,
          flag: 0,
          origin: getCurrentOrigin(state),
        };
      default:
        return;
    }
  },
  [CHANGE_PAGE]: (action, state) => {
    if (_.get(action.payload, 'meta.bi.buttonType')) {
      return {
        evid: 519,
        page_destination: action.payload.page,
        button_type: action.payload.buttonType,
        origin: getCurrentOrigin(state),
      };
    }
  },
  [FETCH_SEARCH_SUCCESS]: (action, state) => ({
    evid: 511,
    origin: getReferrer(state), //TODO: after release when searching 2nd time in search page it should show search page
    referral_info: 'direct',
    search_term: state.search.query,
    result_count_posts: action.payload.posts.length,
    result_count_members: action.payload.users.length,
  }),
  [DELETE_POST_SUCCESS]: (action, state) => ({
    evid: 555,
    post_id: action.payload,
    is_admin: state.auth.currentUser.isOwner ? 1 : 0,
  }),
  [DEMOTE_MODERATOR_SUCCESS]: () => ({
    evid: 580,
  }),
  [PROMOTE_MODERATOR_SUCCESS]: () => ({
    evid: 582,
  }),
  [LOCATION_CHANGE]: (action, state) => {
    const callerLocation = getCurrentLocation(state);
    const location = action.payload;
    const route = detectRoute(location);

    const origin = getCurrentOrigin(state);
    if (route === FEED_PAGE) {
      const categorySlug = getCategorySlugFromPathname(location.pathname);
      const category = getCategoryBySlug(state, categorySlug);
      if (category) {
        return {
          evid: 502,
          category_id: category._id,
          category_slug: category.slug,
          origin,
        };
      }
    }

    if (route === CREATE_POST) {
      return {
        evid: 505,
      };
    }
    if (callerLocation && route === POST_PAGE) {
      let evid, type;

      if (location.hash === '#comments') {
        evid = 518;
        type = 'post_comments';
      } else if (location.hash) {
        evid = 518;
        type = 'comment';
      } else {
        evid = 516;
      }
      const postSlug = getPostSlugFromPathname(location.pathname);
      const post = getPostBySlug(state, postSlug);
      const search_term = detectRoute(callerLocation) === SEARCH_RESULTS ? state.search.query : null;

      if (post) {
        return {
          evid,
          type,
          post_id: post._id,
          post_slug: postSlug,
          origin,
          search_term,
        };
      }
    }
  },
  [UPLOAD_STARTED]: (action, state) => {
    if (action.payload.type === TYPE_IMAGE) {
      return {
        evid: 551,
        origin: getCurrentOrigin(state),
      };
    }
  },
  [UPLOAD_ENDED]: (action, state) => {
    if (action.payload.type === TYPE_IMAGE) {
      return {
        evid: 552,
        origin: getCurrentOrigin(state),
      };
    }
  },
  [INLINE_TOOLBAR_SHOW]: (action, state) => ({
    evid: 509,
    type: getCurrentOrigin(state) === CREATE_POST ? 'post' : 'comment',
  }),
  [BUTTON_CLICKED]: (action, state) => {
    const origin = getCurrentOrigin(state);
    switch (action.payload.name) {
      case 'back_to_categories_menu_click':
        return {
          evid: 548,
        };
      case 'edit_profile_click':
        return {
          evid: 538,
        };
      case 'change_avatar_click':
        return {
          evid: 556,
        };
      case 'change_cover_photo_click':
        return {
          evid: 557,
        };
      case 'back_to_site_click':
        return {
          evid: 547,
          origin,
        };
      case 'search_tab':
        return {
          evid: 536,
          tab_name: action.payload.type,
        };
      case 'notification':
        return {
          evid: 544,
          post_id: state.notifications.byId[action.payload._id].postId,
          type: state.notifications.byId[action.payload._id].type,
        };
      case 'action_click':
        return {
          evid: 526,
          origin,
          ...action.payload,
        };
      case 'cancel-promote-moderator':
        return {
          evid: 581,
        };
      case 'cancel-demote-moderator':
        return {
          evid: 583,
        };
      default:
        console.debug('unmapped event', action);
        return;
    }
  },
  [PAGE_OPENED]: (action, state) => {
    switch (action.payload.page) {
      case POST_PAGE:
        return {
          evid: 517,
          post_id: action.payload.post._id,
          type: action.payload.page,
          post_slug: action.payload.post.title,
          origin: getReferrer(state) || state.siteInfo.referrer,
          search_term: getReferrer(state) === SEARCH_RESULTS ? state.search.query : null,
        };
      case POST_EDIT_PAGE:
        return {
          evid: 506,
        };
      case USER_EDIT_PROFILE:
        return {
          evid: 539,
        };
      case CATEGORIES_PAGE:
        return {
          evid: 501,
          origin: getReferrer(state) || state.siteInfo.referrer,
        };
      case FEED_PAGE:
        return {
          evid: 503,
          origin: getReferrer(state) || state.siteInfo.referrer,
          category_id: action.payload.category._id,
          category_slug: action.payload.category.slug,
        };
      case SEARCH_RESULTS:
        return {
          evid: 535,
        };
      case USER_PROFILE:
        return {
          evid: 537,
          origin: getReferrer(state) || state.siteInfo.referrer,
        };
      case NOTIFICATIONS:
        return {
          evid: 543,
        };
      case USER_SETTINGS:
        return {
          evid: 545,
        };
      default:
        console.debug('unmapped event', action);
        return;
    }
  },
  [CREATE_POST_SUCCESS]: (action, state) => createEditPost(action, state, 'post', false),
  [UPDATE_POST_SUCCESS]: (action, state) => createEditPost(action, state, 'post', true),
  [CREATE_COMMENT_SUCCESS]: (action, state) => createEditPost(action, state, 'comment', false),
  [INCREMENT_COMMENT_LIKE_COUNT_SUCCESS]: (action, state) => ({
    evid: 521,
    post_id: action.payload._id,
    type: 'comment',
    flag: action.payload.isLiked ? 1 : 0,
    origin: getCurrentOrigin(state),
  }),
  [INCREMENT_POST_LIKE_COUNT_SUCCESS]: (action, state) => ({
    evid: 521,
    post_id: action.payload._id,
    type: 'post',
    flag: action.payload.isLiked ? 1 : 0,
    origin: getCurrentOrigin(state),
  }),
  'redux-form/CHANGE': action => {
    switch (action.form) {
      case 'profile':
        return createProfileChangeEvent(action);
      default:
        return;
    }
  },
  'redux-form/START_SUBMIT': action => {
    switch (action.form) {
      case 'post':
        return {
          evid: 508,
        };
      default:
        return;
    }
  },
  [ACTIONS_OPENED]: (action, state) => ({
    evid: 524,
    type: action.payload.type,
    origin: getCurrentOrigin(state),
  }),
  [ACTIONS_CLOSED]: (action, state) => ({
    evid: 525,
    type: action.payload.type,
    origin: getCurrentOrigin(state),
  }),
  [HIDE_MODAL]: (action, state) => {
    const { type } = state.modal;

    const isCancelClicked = action.type === HIDE_MODAL && !action.payload;
    if (isCancelClicked) {
      switch (type) {
        case modalTypes.MODAL_TYPE_PROMOTE_MODERATOR:
          return {
            evid: 581,
          };
        case modalTypes.MODAL_TYPE_DEMOTE_MODERATOR:
          return {
            evid: 583,
          };
        default:
          return;
      }
    }
  },
  [UPDATE_USER_REQUEST]: (action, state) => {
    const emailSettings = _.get(action.payload.data, 'settings.email');
    const oldEmailSettings = _.get(state.auth.currentUser, 'settings.email');
    if (emailSettings) {
      const newSetting = getDifferentSetting(emailSettings, oldEmailSettings);
      return {
        evid: 546,
        settings_type: `email_${newSetting.key}`,
        flag: newSetting.value ? 1 : 0,
      };
    }

    const pushSettings = action.payload.data.settings.push;
    const oldPushSettings = action.payload.data.settings.push;
    if (pushSettings) {
      const newSetting = getDifferentSetting(pushSettings, oldPushSettings);
      return {
        evid: 546,
        settings_type: `push_${newSetting.key}`,
        flag: newSetting.value ? 1 : 0,
      };
    }
  },
  [UPDATE_USER_SUCCESS]: (action, state) => {
    if (action.payload.name !== state.auth.currentUser.name) {
      return {
        evid: 542,
      };
    }
  },
};

function getDifferentSetting(settings, oldSettings) {
  return _.reduce(
    settings,
    (newSetting, value, key) => {
      if (oldSettings[key] !== value) {
        newSetting = {
          key,
          value,
        };
      }
      return newSetting;
    },
    {}
  );
}

function createProfileChangeEvent(action) {
  const { field, value } = action;

  if (value.file_name) {
    switch (field) {
      case 'image':
        return {
          evid: 540,
        };
      case 'cover':
        return {
          evid: 541,
        };
      default:
        return;
    }
  }
}

function createEditPost(action, state, type, isEdit) {
  const entity = action.payload;
  const imageCount = getImageCount(entity);
  const quoteCount = getQuoteCount(entity);
  const videoCount = getVideoCount(entity);
  return {
    evid: 523,
    post_id: entity._id,
    type,
    is_edited: Number(isEdit),
    has_image: imageCount > 0 ? 1 : 0,
    image_count: imageCount,
    has_video: videoCount > 0 ? 1 : 0,
    has_quote: quoteCount > 0 ? 1 : 0,
    is_admin: state.auth.currentUser.isOwner ? 1 : 0,
  };
}

export const endpoint = 'forums-uou';
export const src = 69;



// WEBPACK FOOTER //
// ./app/bi-events/forums-uou-events.js